import React, { useState, useCallback, useEffect } from "react";
import Slider from "react-slick";
import { withRouter } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./MainSlider.scss";

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "transparent",
        right: "10px",
        width: "30px",
        height: "30px",
        zIndex: "2",
      }}
      onClick={onClick}
    />
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "transparent",
        left: "10px",
        width: "30px",
        height: "30px",
        zIndex: "2",
      }}
      onClick={onClick}
    />
  );
};

const MainSlider = (props) => {
  const [dragging, setDragging] = useState(false);
  const [wSize, setWSize] = useState();

  useEffect(() => {
    setWSize(window.innerWidth);
  }, [wSize]);

  const handleBeforeChange = useCallback(() => {
    setDragging(true);
  }, [setDragging]);

  const handleAfterChange = useCallback(() => {
    setDragging(false);
  }, [setDragging]);

  const productShowHandler = useCallback(
    (link) => {
      let linkSplited = link.split("/");
      const id = linkSplited.at(-1);
      if (!dragging) {
        if (linkSplited.at(-2) === "products") {
          props.history.push({
            // pathname: `/products/${id}`,
            pathname: `/products/${id}`,
            state: { productId: id },
          });
        } else if (linkSplited.at(-2) === "blog") {
          props.history.push({
            pathname: `/blog/${id}`,
            state: { blogId: id },
          });
        } else {
          return false;
        }
      }
    },
    [dragging]
  );

  const settings = {
    dots: props.dots,
    infinite: props.infinite,
    // speed: 2000,
    slidesToShow: props.slideCount,
    slidesToScroll: props.sldeToScroll,
    autoplay: props.autoplay,
    autoplaySpeed: props.slideSpeed,
    pauseOnHover: true,
    swipeToSlide: props.swipeToSlide,
    // variableWidth: true,
    // adaptiveHeight: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="SliderWrapper" style={{ width: props.width, height: props.height, position: "relative" }}>
      <Slider {...settings} beforeChange={handleBeforeChange} afterChange={handleAfterChange}>
        {props.sliderData?.length > 0 &&
          props.sliderData?.map((item, index) => {
            let i = {};
            // if (item.type === "DeskTop") {
            if (wSize >= 900 && item.type === "DeskTop") {
              i = item;
              return (
                <div className="sliderImageFigure" key={index}>
                  <a
                    draggable="false"
                    href={`/products/${i.link}`}
                    className="sliderLink"
                    onClick={() => productShowHandler(i.link)}
                  >
                    <img src={i.image} alt={i.detail} className="sliderImage" />
                  </a>
                  {/* <span className="sliderDetail">{item.detail}</span> */}
                </div>
              );
              // } else if (item.type === "Tablet") {
            } else if (wSize >= 576 && wSize <= 899 && item.type === "Tablet") {
              i = item;
              return (
                <div className="sliderImageFigure" key={index}>
                  <a
                    draggable="false"
                    href={`/products/${i.link}`}
                    className="sliderLink"
                    onClick={() => productShowHandler(i.link)}
                  >
                    <img src={i.image} alt={i.detail} className="sliderImage" />
                  </a>
                  {/* <span className="sliderDetail">{item.detail}</span> */}
                </div>
              );
              // } else if (item.type === "Phone") {
            } else if (wSize >= 0 && wSize <= 575 && item.type === "Phone") {
              i = item;
              return (
                <div className="sliderImageFigure" key={index}>
                  <a
                    draggable="false"
                    href={`/products/${i.link}`}
                    className="sliderLink"
                    onClick={() => productShowHandler(i.link)}
                  >
                    <img src={i.image} alt={i.detail} className="sliderImage" />
                  </a>
                  {/* <span className="sliderDetail">{item.detail}</span> */}
                </div>
              );
            }
          })}
      </Slider>
    </div>
  );
};

export default React.memo(withRouter(MainSlider));
